import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// API service class
class ApiService {
  constructor() {
    this.client = axios.create({
      baseURL: API,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  // User endpoints
  async createUser(userData) {
    const response = await this.client.post('/users', userData);
    return response.data;
  }

  async getUser(userId) {
    const response = await this.client.get(`/users/${userId}`);
    return response.data;
  }

  async getUserByMilitaryId(militaryId) {
    const response = await this.client.get(`/users/military/${militaryId}`);
    return response.data;
  }

  async updateUser(userId, updateData) {
    const response = await this.client.put(`/users/${userId}`, updateData);
    return response.data;
  }

  async getUsers() {
    const response = await this.client.get('/users');
    return response.data;
  }

  // Benefits endpoints
  async getUserBenefits(userId) {
    const response = await this.client.get(`/users/${userId}/benefits`);
    return response.data;
  }

  async createBenefit(benefitData) {
    const response = await this.client.post('/benefits', benefitData);
    return response.data;
  }

  async updateBenefit(benefitId, updateData) {
    const response = await this.client.put(`/benefits/${benefitId}`, updateData);
    return response.data;
  }

  async getActiveBenefits(userId) {
    const response = await this.client.get(`/users/${userId}/benefits/active`);
    return response.data;
  }

  // Documents endpoints
  async getUserDocuments(userId) {
    const response = await this.client.get(`/users/${userId}/documents`);
    return response.data;
  }

  async createDocument(documentData) {
    const response = await this.client.post('/documents', documentData);
    return response.data;
  }

  async processDocument(documentId) {
    const response = await this.client.post(`/documents/${documentId}/process`);
    return response.data;
  }

  // Notifications endpoints
  async getUserNotifications(userId, limit = 50) {
    const response = await this.client.get(`/users/${userId}/notifications?limit=${limit}`);
    return response.data;
  }

  async markNotificationRead(notificationId) {
    const response = await this.client.put(`/notifications/${notificationId}/read`);
    return response.data;
  }

  async getUnreadCount(userId) {
    const response = await this.client.get(`/users/${userId}/notifications/unread-count`);
    return response.data;
  }

  // Chat endpoints
  async createChatMessage(messageData) {
    const response = await this.client.post('/chat/messages', messageData);
    return response.data;
  }

  async getSessionMessages(sessionId, limit = 100) {
    const response = await this.client.get(`/chat/sessions/${sessionId}/messages?limit=${limit}`);
    return response.data;
  }

  async getAIResponse(sessionId, userId, message) {
    const response = await this.client.post('/chat/ai-response', null, {
      params: { session_id: sessionId, user_id: userId, message }
    });
    return response.data;
  }

  async getUserSessions(userId) {
    const response = await this.client.get(`/users/${userId}/chat/sessions`);
    return response.data;
  }

  // AI Insights endpoints
  async getUserInsights(userId) {
    const response = await this.client.get(`/users/${userId}/ai-insights`);
    return response.data;
  }

  async generateInsights(userId) {
    const response = await this.client.post(`/users/${userId}/ai-insights/generate`);
    return response.data;
  }

  async getBenefitRecommendations(userId) {
    const response = await this.client.get(`/users/${userId}/ai-insights/recommendations`);
    return response.data;
  }

  // Demo data setup
  async setupDemoData(userId) {
    const response = await this.client.post(`/demo/setup/${userId}`);
    return response.data;
  }

  // Health check
  async healthCheck() {
    const response = await this.client.get('/');
    return response.data;
  }

  // Generic request method for AI chat
  async request(method, endpoint, data = null) {
    const config = {
      method: method.toLowerCase(),
      url: endpoint
    };
    
    if (data && (method.toUpperCase() === 'POST' || method.toUpperCase() === 'PUT')) {
      config.data = data;
    }
    
    const response = await this.client.request(config);
    return response.data;
  }

  // Benefits API methods
  async createBenefit(benefitData) {
    const response = await this.client.post('/benefits', benefitData);
    return response.data;
  }

  async getUserBenefits(userId) {
    const response = await this.client.get(`/users/${userId}/benefits`);
    return response.data;
  }
}

export default new ApiService();